export const ROOT = '/';
export const MODULE = 'DASHBOARD';
